import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from './useAuth'

export function usePositions() {
  const { user } = useAuth()
  const [positions, setPositions] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) return
    fetchPositions()
  }, [user])

  async function fetchPositions() {
    if (positions.length === 0) setLoading(true)
    const { data, error } = await supabase
      .from('positions')
      .select('*')
      .eq('user_id', user.id)
      .order('opened_at', { ascending: false })
    if (!error && data) setPositions(data)
    setLoading(false)
  }

  async function addPosition(positionData) {
    const { data, error } = await supabase
      .from('positions')
      .insert({ ...positionData, user_id: user.id })
      .select()
      .single()
    if (!error && data) setPositions(prev => [data, ...prev])
    return { data, error }
  }

  async function updatePosition(id, updates) {
    const { data, error } = await supabase
      .from('positions')
      .update(updates)
      .eq('id', id)
      .select()
      .single()
    if (!error && data) {
      setPositions(prev => prev.map(p => p.id === id ? data : p))
    }
    return { data, error }
  }

  async function closePosition(id, closePrice, closeDate) {
    return updatePosition(id, {
      status: 'closed',
      close_price: closePrice,
      closed_at: closeDate || new Date().toISOString(),
    })
  }

  async function deletePosition(id) {
    const { error } = await supabase
      .from('positions')
      .delete()
      .eq('id', id)
    if (!error) setPositions(prev => prev.filter(p => p.id !== id))
    return { error }
  }

  const openPositions = positions.filter(p => p.status === 'open')
  const closedPositions = positions.filter(p => p.status === 'closed')

  return {
    positions, openPositions, closedPositions, loading,
    addPosition, updatePosition, closePosition, deletePosition,
    refetch: fetchPositions,
  }
}
